import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderRivne(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-rivne/create-distribution-order-rivne",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderRivne(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-rivne/create-distribution-to-order-rivne",
      params,
      callBackFn
    );
  },
  async getRivneAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-rivne/get-rivne-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
